import AvaCAS from 'ava-cas-iframe';

const init = (doc) => new Promise((resolve, reject) => {
  window.AvaCAS = new AvaCAS(doc, {
    src: process.env.REACT_APP_CAS_SRC || undefined,
    postMessageSrc: process.env.REACT_APP_CAS_POST_MESSAGE_SRC || undefined,
    usersUrl: process.env.REACT_APP_CAS_URL,
    pusher: {
      id: process.env.REACT_APP_PUSHER_ID,
      cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    },
  });
  console.time('init');
  window.AvaCAS.showLoader();
  window.AvaCAS.init()
    .then((data) => {
      window.AvaCAS.hideLoader();
      resolve({ cas: window.AvaCAS, data });
    }, (data) => {
      console.log(data);

      console.error('Failed to load CAS iFrame.');
      reject(new Error('CAS failed to load'));
    })
    .then(() => {
      console.timeEnd('init');
    });
});

export default init;



// WEBPACK FOOTER //
// ./src/bootstrap/registerAvaCAS.js